if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.currentIndex = 0;
        this.mediaItems = [];
        this.navigation = null;
        this.previousButton = null;
        this.nextButton = null;
        this.zoomedImage = null;

       /* =====================================================
   MOBILE IMAGE ZOOM
   Supports:
   - Pinch-to-zoom on Android
   - Pinch-to-zoom on iPhone
   - Tap-to-zoom
   - Tap again to reset
   ===================================================== */

this.pinchStartDistance = 0;
this.pinchStartScale = 1;
this.currentScale = 1;
this.isPinching = false;
this.pinchMoved = false;

this.addEventListener(
  'pointerdown',
  (event) => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    if (
      event.target.closest('.product-modal__arrow') ||
      event.target.closest('.product-media-modal__toggle')
    ) {
      return;
    }

    const activeMedia = this.querySelector(
      '.product-media-modal__content > *.active'
    );

    if (!activeMedia) return;

    const image = activeMedia.querySelector('img');

    if (!image) return;
   

    /* Store active pointers */
    if (!this.activePointers) {
      this.activePointers = new Map();
    }

    this.activePointers.set(event.pointerId, {
      x: event.clientX,
      y: event.clientY,
    });

    /* Start pinch */
    if (this.activePointers.size === 2) {
      const points = Array.from(this.activePointers.values());

      const dx = points[0].x - points[1].x;
      const dy = points[0].y - points[1].y;

      this.pinchStartDistance = Math.sqrt(
        dx * dx + dy * dy
      );

      this.pinchStartScale = this.currentScale || 1;

      this.isPinching = true;
      this.pinchMoved = false;

      event.preventDefault();
    }
  },
  { passive: false }
);


/* =====================================================
   PINCH MOVE
   ===================================================== */

this.addEventListener(
  'pointermove',
  (event) => {
    if (!this.activePointers) return;

    if (!this.activePointers.has(event.pointerId)) return;

    this.activePointers.set(event.pointerId, {
      x: event.clientX,
      y: event.clientY,
    });

    if (this.activePointers.size !== 2) return;

    const activeMedia = this.querySelector(
      '.product-media-modal__content > *.active'
    );

    if (!activeMedia) return;

    const image = activeMedia.querySelector('img');

    if (!image) return;

    const points = Array.from(this.activePointers.values());

    const dx = points[0].x - points[1].x;
    const dy = points[0].y - points[1].y;

    const distance = Math.sqrt(
      dx * dx + dy * dy
    );

    if (!this.pinchStartDistance) return;

    let scale =
      this.pinchStartScale *
      (distance / this.pinchStartDistance);

    /* Limit zoom */
    scale = Math.max(1, Math.min(scale, 3));

    this.currentScale = scale;
    this.pinchMoved = true;

    image.classList.add('stilento-image-zoomed');

    image.style.transformOrigin = 'center center';
    image.style.transform = `scale(${scale})`;

    event.preventDefault();
  },
  { passive: false }
);


/* =====================================================
   POINTER UP
   ===================================================== */

this.addEventListener(
  'pointerup',
  (event) => {
    if (this.activePointers) {
      this.activePointers.delete(event.pointerId);

      if (this.activePointers.size < 2) {
        this.pinchStartDistance = 0;
      }
    }
  },
  { passive: false }
);


/* =====================================================
   POINTER CANCEL
   ===================================================== */

this.addEventListener(
  'pointercancel',
  (event) => {
    if (this.activePointers) {
      this.activePointers.delete(event.pointerId);

      if (this.activePointers.size < 2) {
        this.pinchStartDistance = 0;
      }
    }
  },
  { passive: false }
);


/* =====================================================
   TAP TO ZOOM
   ===================================================== */

this.addEventListener(
  'click',
  (event) => {

    if (!window.matchMedia('(max-width: 749px)').matches) {
      return;
    }

    /* Don't interfere with arrows or close */
    if (
      event.target.closest('.product-modal__arrow') ||
      event.target.closest('.product-media-modal__toggle')
    ) {
      return;
    }

    /* Don't trigger tap zoom after pinch */
    if (this.pinchMoved || this.isPinching) {
      this.pinchMoved = false;
      this.isPinching = false;
      return;
    }

    const activeMedia = this.querySelector(
      '.product-media-modal__content > *.active'
    );

    if (!activeMedia) return;

    const image = activeMedia.querySelector('img');

    if (!image) return;

    const rect = image.getBoundingClientRect();

    const insideImage =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;

    if (!insideImage) return;

    event.preventDefault();
    event.stopPropagation();

    const isZoomed =
      image.classList.contains('stilento-image-zoomed');

    if (isZoomed) {
      this.resetZoom();
      return;
    }

    const x =
      ((event.clientX - rect.left) / rect.width) * 100;

    const y =
      ((event.clientY - rect.top) / rect.height) * 100;

    image.style.transformOrigin = `${x}% ${y}%`;

    image.style.transform = 'scale(2)';

    image.classList.add('stilento-image-zoomed');

    this.currentScale = 2;
    this.zoomedImage = image;
  },
  true
);
}

      /* =====================================================
         CLOSE MODAL
         ===================================================== */

      hide() {
        this.resetZoom();
        super.hide();
      }

      /* =====================================================
         OPEN MODAL
         ===================================================== */

      show(opener) {
        super.show(opener);

        this.mediaItems = Array.from(
          this.querySelectorAll('[data-media-id]')
        );

        this.currentIndex = this.mediaItems.findIndex(
          (media) =>
            media.getAttribute('data-media-id') ===
            opener.getAttribute('data-media-id')
        );

        if (this.currentIndex < 0) {
          this.currentIndex = 0;
        }

        this.createNavigation();
        this.showActiveMedia();
      }

      /* =====================================================
         CREATE NAVIGATION
         ===================================================== */

      createNavigation() {
        if (this.navigation) return;

        const dialog = this.querySelector(
          '.product-media-modal__dialog'
        );

        if (!dialog) return;

        this.navigation = document.createElement('div');
        this.navigation.className =
          'product-modal__navigation';

        /* PREVIOUS */

        this.previousButton =
          document.createElement('button');

        this.previousButton.type = 'button';

        this.previousButton.className =
          'product-modal__arrow product-modal__arrow--prev';

        this.previousButton.setAttribute(
          'aria-label',
          'Previous image'
        );

        this.previousButton.innerHTML = '&#10094;';

        /* NEXT */

        this.nextButton =
          document.createElement('button');

        this.nextButton.type = 'button';

        this.nextButton.className =
          'product-modal__arrow product-modal__arrow--next';

        this.nextButton.setAttribute(
          'aria-label',
          'Next image'
        );

        this.nextButton.innerHTML = '&#10095;';

        /* Previous events */

        this.previousButton.addEventListener(
          'pointerdown',
          (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        );

        this.previousButton.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();

            this.showPreviousMedia();
          }
        );

        /* Next events */

        this.nextButton.addEventListener(
          'pointerdown',
          (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        );

        this.nextButton.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();

            this.showNextMedia();
          }
        );

        this.navigation.appendChild(
          this.previousButton
        );

        this.navigation.appendChild(
          this.nextButton
        );

        dialog.appendChild(this.navigation);

        /*
         * Move Shopify's existing close button
         */

        const closeButton = this.querySelector(
          '.product-media-modal__toggle'
        );

        if (closeButton) {
          closeButton.classList.add(
            'product-modal__bottom-close'
          );

          this.navigation.appendChild(closeButton);
        }
      }

      /* =====================================================
         PREVIOUS IMAGE
         ===================================================== */

      showPreviousMedia() {
        if (this.mediaItems.length <= 1) return;

        this.resetZoom();

        this.currentIndex--;

        if (this.currentIndex < 0) {
          this.currentIndex =
            this.mediaItems.length - 1;
        }

        this.showMediaByIndex();
      }

      /* =====================================================
         NEXT IMAGE
         ===================================================== */

      showNextMedia() {
        if (this.mediaItems.length <= 1) return;

        this.resetZoom();

        this.currentIndex++;

        if (
          this.currentIndex >=
          this.mediaItems.length
        ) {
          this.currentIndex = 0;
        }

        this.showMediaByIndex();
      }

      /* =====================================================
         DISPLAY IMAGE
         ===================================================== */

      showMediaByIndex() {
        const media =
          this.mediaItems[this.currentIndex];

        if (!media) return;

        this.mediaItems.forEach((element) => {
          element.classList.remove('active');
        });

        media.classList.add('active');

        const container =
          this.querySelector('[role="document"]');

        if (container) {
          container.scrollTop = 0;
          container.scrollLeft = 0;
        }

        const activeMediaTemplate =
          media.querySelector('template');

        const activeMediaContent =
          activeMediaTemplate
            ? activeMediaTemplate.content
            : null;

        if (
          media.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          media.loadContent();
        }

        this.updateNavigation();
      }

      /* =====================================================
         ARROWS
         ===================================================== */

      updateNavigation() {
        if (
          !this.previousButton ||
          !this.nextButton
        ) {
          return;
        }

        const showArrows =
          this.mediaItems.length > 1;

        this.previousButton.style.display =
          showArrows ? 'flex' : 'none';

        this.nextButton.style.display =
          showArrows ? 'flex' : 'none';
      }

      /* =====================================================
         INITIAL ACTIVE IMAGE
         ===================================================== */

      showActiveMedia() {
        this.resetZoom();

        this.mediaItems.forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia =
          this.mediaItems[this.currentIndex];

        if (!activeMedia) return;

        activeMedia.classList.add('active');

        const container =
          this.querySelector('[role="document"]');

        if (container) {
          container.scrollTop = 0;
          container.scrollLeft = 0;
        }

        const activeMediaTemplate =
          activeMedia.querySelector('template');

        const activeMediaContent =
          activeMediaTemplate
            ? activeMediaTemplate.content
            : null;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }

        this.updateNavigation();
      }

      /* =====================================================
         RESET ZOOM
         ===================================================== */

      resetZoom() {
        this.querySelectorAll(
          '.stilento-image-zoomed'
        ).forEach((image) => {
          image.classList.remove(
            'stilento-image-zoomed'
          );

          image.style.transform = 'scale(1)';
          image.style.transformOrigin =
            'center center';
          image.style.touchAction = '';
        });

        this.zoomedImage = null;
        this.currentScale = 1;
        this.pinchStartDistance = 0;
        this.isPinching = false;
        this.pinchMoved = false;

        if (this.activePointers) {
          this.activePointers.clear();
        }
      }
    }
  );
}